var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6667 35V31.6667C33.6667 29.8986 32.9643 28.2029 31.714 26.9526C30.4638 25.7024 28.7681 25 27 25H13.6667C11.8986 25 10.2029 25.7024 8.95262 26.9526C7.70238 28.2029 7 29.8986 7 31.6667V35M27 11.6667C27 15.3486 24.0152 18.3333 20.3333 18.3333C16.6514 18.3333 13.6667 15.3486 13.6667 11.6667C13.6667 7.98477 16.6514 5 20.3333 5C24.0152 5 27 7.98477 27 11.6667Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon40);
export default __webpack_public_path__ + "static/media/user-icon-40.e6694f306f592f45f9cb76739bb1a766.svg";
export { ForwardRef as ReactComponent };